import { render, staticRenderFns } from "./KaiHeader.vue?vue&type=template&id=6c59a256&"
import script from "./KaiHeader.vue?vue&type=script&lang=ts&"
export * from "./KaiHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports